module.exports = __webpack_public_path__ + "img/bg-header-sp.92f57acd.png";